import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const FailedPatchesDialog = ({ open, onClose, failedPatches, onAcknowledge }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: { borderRadius: 3, direction: "ltr", minWidth: 320, maxWidth: 500 },
    }}
  >
    <DialogTitle
      sx={{
        fontWeight: 700,
        fontSize: "1.05rem",
        pb: 1,
        display: "flex",
        alignItems: "center",
        gap: 1,
        color: "#d32f2f",
      }}
    >
      <WarningAmberIcon sx={{ fontSize: 28 }} />
      שגיאה בעדכון Priority
    </DialogTitle>
    <DialogContent>
      <Typography sx={{ fontSize: "0.95rem", color: "#555", mb: 2, lineHeight: 1.6 }}>
        המיפוי נשמר בהצלחה ל-MongoDB, אך חלק מהמכשירים עם חריגה נכשלו בעדכון ל-Priority:
      </Typography>
      <Box
        sx={{
          maxHeight: 300,
          overflow: "auto",
          bgcolor: "#fff3cd",
          borderRadius: 2,
          p: 1.5,
          border: "1px solid #ffc107",
        }}
      >
        {failedPatches.map((item, index) => (
          <Box
            key={index}
            sx={{
              p: 1.5,
              mb: index < failedPatches.length - 1 ? 1 : 0,
              bgcolor: "#fff",
              borderRadius: 1.5,
              border: "1px solid #ffe082",
            }}
          >
            <Typography sx={{ fontSize: "0.9rem", fontWeight: 600, color: "#333" }}>
              <strong>סיריאלי:</strong> {item.SERNUM}
            </Typography>
            <Typography sx={{ fontSize: "0.88rem", color: "#555", mt: 0.5 }}>
              <strong>מק"ט:</strong> {item.PARTNAME}
            </Typography>
            {item.error && (
              <Typography
                sx={{ fontSize: "0.82rem", color: "#666", mt: 0.5, fontStyle: "italic" }}
              >
                שגיאה:{" "}
                {typeof item.error === "string" ? item.error : JSON.stringify(item.error)}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
      <Typography sx={{ fontSize: "0.88rem", color: "#666", mt: 2, fontStyle: "italic" }}>
        יש לבדוק ולעדכן מכשירים אלו ידנית ב-Priority
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 2, pb: 2 }}>
      <Button
        variant="contained"
        onClick={onAcknowledge}
        sx={{
          flex: 1,
          borderRadius: 2,
          fontWeight: 600,
          bgcolor: "#ff9800",
          "&:hover": { bgcolor: "#f57c00" },
        }}
      >
        הבנתי
      </Button>
    </DialogActions>
  </Dialog>
);

export default FailedPatchesDialog;
